import React from 'react'
import { ModalConsulta } from '.';
import { Tabela } from '../Basicos';

function ModalConsultaListavariaveis(props) {
    const { estrutura } = props;
    const { alunos } = estrutura?.modal;

    const columns = React.useMemo(
        () => [{
            Header: "listavariaveis",
            style: {
                display: 'none',
            },
            columns: [
                {
                    Header: 'Objeto',
                    accessor: 'objeto',
                },
                {
                    Header: 'Nome Variável',
                    accessor: 'nome',
                },
                {
                    Header: 'Descrição Variável',
                    accessor: 'descricao',
                },
                {
                    Header: 'Tipo Variável',
                    accessor: 'tipo'
                }
            ],
        }],
        []
    )

    return (
        <ModalConsulta
            data={props.data}
            modalClass="modal-map"
            modalBodyClass="modalConsulta"
            size="lg"

            {...props}
        >
            <Tabela
                columns={columns}
                data={alunos}
                tabelaClassName="tabelaConsulta"
            />
        </ModalConsulta>
    );
}

export default ModalConsultaListavariaveis;
